<rask-fieldset-toggle
    label="Tillgänglighet väg"
    [formGroup]="form"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-checkbox-list
        label="Tillgänglighet väg"
        [formControlName]="name"
        [items]="options"
        [selected]="form.value.tillganglighetVag">
    </rask-checkbox-list>
</rask-fieldset-toggle>